import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {InvitedUserPill} from '@mintdata-wsp/wsp/ui/dialogs/publish/invite/InvitedUserPill';
import {InvitorInput} from '@mintdata-wsp/wsp/ui/dialogs/publish/invite/InvitorInput';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {FormFieldValidationResult} from "@mintdata-wsp/common/components/form/Form";

const styles = require('./Invitor.less');
const cx = classnames.bind(styles);

export interface InvitorProps
{
    className?:string;
    onChange?:(emails:string[]) => void;
    validateFn?:(email:string)=>(Promise<FormFieldValidationResult>);
}

export class InvitedUser
{
    private constructor(public uniqueId:string, public email:string)
    {
    }

    public static fromEmail(email:string):InvitedUser
    {
        const uniqueId = IdUtil.newGUID();
        return new InvitedUser(uniqueId, email);
    }
}

@observer
export class Invitor extends React.Component<InvitorProps, any>
{
    @observable
    private _invitedUsers:InvitedUser[] = [];

    private _pillContainerRef:HTMLElement = null;

    @bind
    private _onPillContainerRef(ref:HTMLElement):void
    {
        this._pillContainerRef = ref;
    }

    @action.bound
    private _onEnteredEmail(email:string)
    {
        this._invitedUsers.push(InvitedUser.fromEmail(email));
        this._onChange();
    }

    @action.bound
    private _onUserRemoved(user:InvitedUser)
    {
        let idx = this._invitedUsers.indexOf(user);

        if( idx !== -1 )
        {
            this._invitedUsers.splice(idx, 1);
            this._onChange();
        }
    }

    @bind
    private _onChange()
    {
        const {onChange} = this.props;

        if( onChange && typeof onChange === 'function' )
        {
            onChange(this._invitedUsers.map(user => user.email));
        }
    }

    @bind
    private _scrollPillContainerToBottom():void
    {
        setTimeout(() =>
        {
            if( this._pillContainerRef )
                this._pillContainerRef.scrollTop = 100000; // todo: compute properly
        }, 0);
    }

    render()
    {
        let {className, validateFn} = this.props;
        this._scrollPillContainerToBottom();

        return (
            <Column className={cx('invitor', className)}>

                <div className={cx('inviteePillsContainer')} ref={this._onPillContainerRef}>
                    <Row className={cx('inviteePills')}>
                        {
                            this._invitedUsers.map((invitedUser:InvitedUser) =>
                            {
                                return <InvitedUserPill key={invitedUser.uniqueId}
                                                        invitedUser={invitedUser}
                                                        onUserRemoved={this._onUserRemoved}
                                />;
                            })
                        }
                    </Row>
                </div>

                <InvitorInput onEnteredEmail={this._onEnteredEmail} validateFn={validateFn} />

            </Column>
        );
    }
}
